import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Eye, EyeOff } from 'lucide-react';
const Register = () => {
  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const navigate = useNavigate();
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const {
      name,
      value
    } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    // In a real app, you would handle registration here
    console.log('Registration attempt with:', formData);
    navigate('/dashboard');
  };
  return <div className="min-h-screen bg-gray-50 flex flex-col justify-center py-12 sm:px-6 lg:px-8" data-id="element-1475">
      <div className="sm:mx-auto sm:w-full sm:max-w-md" data-id="element-1476">
        <Link to="/" className="flex justify-center" data-id="element-1477">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/2KtfgpX5czTsCWioSSfnqq/billvast_logoBB.png" alt="BillVast Logo" className="h-14 w-auto" data-id="element-1478" />
        </Link>
        <h2 className="mt-6 text-center text-3xl font-extrabold text-gray-900" data-id="element-1479">
          Create your account
        </h2>
        <p className="mt-2 text-center text-sm text-gray-600" data-id="element-1480">
          Or{' '}
          <Link to="/login" className="font-medium text-[#289f77] hover:text-[#115800]" data-id="element-1481">
            sign in to your existing account
          </Link>
        </p>
      </div>
      <div className="mt-8 sm:mx-auto sm:w-full sm:max-w-md" data-id="element-1482">
        <div className="bg-white py-8 px-4 shadow sm:rounded-lg sm:px-10" data-id="element-1483">
          <form className="space-y-6" onSubmit={handleSubmit} data-id="element-1484">
            <div className="grid grid-cols-1 gap-6 sm:grid-cols-2" data-id="element-1485">
              <div data-id="element-1486">
                <label htmlFor="firstName" className="block text-sm font-medium text-gray-700" data-id="element-1487">
                  First name
                </label>
                <div className="mt-1" data-id="element-1488">
                  <input id="firstName" name="firstName" type="text" autoComplete="given-name" required value={formData.firstName} onChange={handleChange} className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#289f77] focus:border-[#289f77] sm:text-sm" data-id="element-1489" />
                </div>
              </div>
              <div data-id="element-1490">
                <label htmlFor="lastName" className="block text-sm font-medium text-gray-700" data-id="element-1491">
                  Last name
                </label>
                <div className="mt-1" data-id="element-1492">
                  <input id="lastName" name="lastName" type="text" autoComplete="family-name" required value={formData.lastName} onChange={handleChange} className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#289f77] focus:border-[#289f77] sm:text-sm" data-id="element-1493" />
                </div>
              </div>
            </div>
            <div data-id="element-1494">
              <label htmlFor="email" className="block text-sm font-medium text-gray-700" data-id="element-1495">
                Email address
              </label>
              <div className="mt-1" data-id="element-1496">
                <input id="email" name="email" type="email" autoComplete="email" required value={formData.email} onChange={handleChange} className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#289f77] focus:border-[#289f77] sm:text-sm" data-id="element-1497" />
              </div>
            </div>
            <div data-id="element-1498">
              <label htmlFor="password" className="block text-sm font-medium text-gray-700" data-id="element-1499">
                Password
              </label>
              <div className="mt-1 relative" data-id="element-1500">
                <input id="password" name="password" type={showPassword ? 'text' : 'password'} autoComplete="new-password" required value={formData.password} onChange={handleChange} className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#289f77] focus:border-[#289f77] sm:text-sm pr-10" data-id="element-1501" />
                <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center" onClick={() => setShowPassword(!showPassword)} data-id="element-1502">
                  {showPassword ? <EyeOff className="h-5 w-5 text-gray-400" data-id="element-1503" /> : <Eye className="h-5 w-5 text-gray-400" data-id="element-1504" />}
                </button>
              </div>
            </div>
            <div data-id="element-1505">
              <label htmlFor="confirmPassword" className="block text-sm font-medium text-gray-700" data-id="element-1506">
                Confirm password
              </label>
              <div className="mt-1 relative" data-id="element-1507">
                <input id="confirmPassword" name="confirmPassword" type={showConfirmPassword ? 'text' : 'password'} autoComplete="new-password" required value={formData.confirmPassword} onChange={handleChange} className="appearance-none block w-full px-3 py-2 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-[#289f77] focus:border-[#289f77] sm:text-sm pr-10" data-id="element-1508" />
                <button type="button" className="absolute inset-y-0 right-0 pr-3 flex items-center" onClick={() => setShowConfirmPassword(!showConfirmPassword)} data-id="element-1509">
                  {showConfirmPassword ? <EyeOff className="h-5 w-5 text-gray-400" data-id="element-1510" /> : <Eye className="h-5 w-5 text-gray-400" data-id="element-1511" />}
                </button>
              </div>
            </div>
            <div className="flex items-center" data-id="element-1512">
              <input id="terms" name="terms" type="checkbox" required className="h-4 w-4 text-[#289f77] focus:ring-[#289f77] border-gray-300 rounded" data-id="element-1513" />
              <label htmlFor="terms" className="ml-2 block text-sm text-gray-900" data-id="element-1514">
                I agree to the{' '}
                <a href="#" className="font-medium text-[#289f77] hover:text-[#115800]" data-id="element-1515">
                  Terms and Conditions
                </a>{' '}
                and{' '}
                <a href="#" className="font-medium text-[#289f77] hover:text-[#115800]" data-id="element-1516">
                  Privacy Policy
                </a>
              </label>
            </div>
            <div data-id="element-1517">
              <button type="submit" className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-[#289f77] hover:bg-[#115800] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#289f77]" data-id="element-1518">
                Create account
              </button>
            </div>
          </form>
          <div className="mt-6" data-id="element-1519">
            <div className="relative" data-id="element-1520">
              <div className="absolute inset-0 flex items-center" data-id="element-1521">
                <div className="w-full border-t border-gray-300" data-id="element-1522"></div>
              </div>
              <div className="relative flex justify-center text-sm" data-id="element-1523">
                <span className="px-2 bg-white text-gray-500" data-id="element-1524">
                  Or continue with
                </span>
              </div>
            </div>
            <div className="mt-6 grid grid-cols-2 gap-3" data-id="element-1525">
              <div data-id="element-1526">
                <a href="#" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-1527">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" data-id="element-1528">
                    <path fillRule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clipRule="evenodd" data-id="element-1529" />
                  </svg>
                </a>
              </div>
              <div data-id="element-1530">
                <a href="#" className="w-full inline-flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm bg-white text-sm font-medium text-gray-500 hover:bg-gray-50" data-id="element-1531">
                  <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" data-id="element-1532">
                    <path fillRule="evenodd" d="M10 0C4.477 0 0 4.484 0 10.017c0 4.425 2.865 8.18 6.839 9.504.5.092.682-.217.682-.483 0-.237-.008-.868-.013-1.703-2.782.605-3.369-1.343-3.369-1.343-.454-1.158-1.11-1.466-1.11-1.466-.908-.62.069-.608.069-.608 1.003.07 1.531 1.032 1.531 1.032.892 1.53 2.341 1.088 2.91.832.092-.647.35-1.088.636-1.338-2.22-.253-4.555-1.113-4.555-4.951 0-1.093.39-1.988 1.029-2.688-.103-.253-.446-1.272.098-2.65 0 0 .84-.27 2.75 1.026A9.564 9.564 0 0110 4.844c.85.004 1.705.115 2.504.337 1.909-1.296 2.747-1.027 2.747-1.027.546 1.379.203 2.398.1 2.651.64.7 1.028 1.595 1.028 2.688 0 3.848-2.339 4.695-4.566 4.942.359.31.678.921.678 1.856 0 1.338-.012 2.419-.012 2.747 0 .268.18.58.688.482A10.019 10.019 0 0020 10.017C20 4.484 15.522 0 10 0z" clipRule="evenodd" data-id="element-1533" />
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};
export default Register;